<template>
  <section class="section --overlap">
    <TitleBlock :content="content" />
    <a :href="content.link" target="_blank" class="button --center" v-reveal="{ delay: 250 }">{{
      content.button
    }}</a>
  </section>
</template>

<script>
import TitleBlock from '@/components/blocks/TitleBlock.vue'
import HasContentProp from '@/mixins/HasContentProp'

export default {
  name: 'SmallCTASection',
  mixins: [HasContentProp],
  components: { TitleBlock },
}
</script>
